import React from "react";

const WandIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path
    d="M12.5 3.33329V1.66663M12.5 13.3333V11.6666M6.66667 7.49996H8.33333M16.6667 7.49996H18.3333M14.8333 9.83329L15.8333 10.8333M14.8333 5.16663L15.8333 4.16663M2.5 17.5L10 9.99996M10.1667 5.16663L9.16667 4.16663"
    stroke="#4548C4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
</svg>;

export default WandIcon;
